"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// @index('./*.ts', pp => `export * from '${pp.path}';`)
__export(require("./GlobalDisclaimerLevel"));
__export(require("./GlobalDisclaimerStoreValue"));
//# sourceMappingURL=index.js.map